import Image from 'next/image';
import {
  MdAttachFile,
  MdAttractions,
  MdCalendarToday,
  MdCardGiftcard,
  MdEdit,
  MdFavorite,
  MdGroups,
  MdLiveHelp,
  MdOutlineLiveTv,
  MdPeople,
} from 'react-icons/md';
import {
  GUILD_ICON,
  GUILD_ICON_PRIMARY,
} from '../../../../../../config/constants/img';
import {
  BOX_DIR_FIRST,
  CLIP_REPORTS,
  COMMUNITY,
  MYPAGE_FAVS_COMPANIES,
  PROFILE_BASE,
} from '../../../../../../config/constants/routes';
import type {TabMenuItem} from './TabMenu';

export type NavValueType = (typeof NAV_VALUE)[keyof typeof NAV_VALUE];

export const NAV_VALUE = {
  RECOMMEND: 'recommend',
  MY_PAGE: 'mypage',
} as const;

const ICON_SIZE = 24;

const recommendMenu: TabMenuItem[] = [
  {
    icon: (
      <>
        <Image
          src={GUILD_ICON}
          alt="Guild"
          width={ICON_SIZE}
          height={ICON_SIZE}
          className="hidden pc:block"
        />
        <Image
          src={GUILD_ICON_PRIMARY}
          alt="Guild"
          width={ICON_SIZE}
          height={ICON_SIZE}
          className="pc:hidden"
        />
      </>
    ),
    label: 'Guild',
    url: 'https://event.gaishishukatsu.com/gsskt-engineer-guild',
    isExternal: true,
  },
  {
    icon: <MdAttractions size={ICON_SIZE} />,
    label: 'イベント',
    url: 'https://event.gaishishukatsu.com/',
    isExternal: true,
  },
  {icon: <MdOutlineLiveTv size={ICON_SIZE} />, label: 'Web合説', url: ''},
  {icon: <MdPeople size={ICON_SIZE} />, label: 'コミュニティ', url: COMMUNITY},
  {icon: <MdLiveHelp size={ICON_SIZE} />, label: '相談室', url: BOX_DIR_FIRST},
  {icon: <MdCardGiftcard size={ICON_SIZE} />, label: '友達紹介', url: ''},
];
const myPageMenu: TabMenuItem[] = [
  {
    icon: <MdCalendarToday size={ICON_SIZE} />,
    label: 'カレンダー',
    url: '/schedule',
  },
  {
    icon: <MdGroups size={ICON_SIZE} />,
    label: 'フォロー中',
    url: MYPAGE_FAVS_COMPANIES,
  },
  {
    icon: <MdAttachFile size={ICON_SIZE} />,
    label: 'クリップ',
    url: CLIP_REPORTS,
  },
  {
    icon: <MdFavorite size={ICON_SIZE} />,
    label: '興味あり',
    url: '/myInterests',
  },
  {icon: <MdEdit size={ICON_SIZE} />, label: 'プロフ編集', url: PROFILE_BASE},
];

export type NavigationMenuType = {
  value: NavValueType;
  items: TabMenuItem[];
  name: string;
};

export const NAVIGATION_MENU: NavigationMenuType[] = [
  {
    value: NAV_VALUE.RECOMMEND,
    items: recommendMenu,
    name: 'おすすめ',
  },
  {
    value: NAV_VALUE.MY_PAGE,
    items: myPageMenu,
    name: 'マイページ',
  },
] as const;
